/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { PriceHandler } from '../../../../redux/helper/CamelCase';

export default function AppliedOfferToolTip({ hover, prod }) {
    return (
        <div
            id="tooltip-discountPercentage1"
            role="tooltip"
            className={`inline-block absolute ${hover || Number(prod.total_discount) > 0 ? 'visible' : 'invisible'} z-10 left-0 sm:pl-5 sm:pr-4 px-2 pb-2 sm:pt-4 pt-2.5 bg-white rounded-lg shadow-s2 sm:min-w-[284px] w-[250px]`}
        >
            <p className="text-xs6 font-semibold text-[#090406]">Offer Applied</p>
            <div className="flex items-center justify-between pt-2.5">
                <p className="text-sm font-normal text-[#555259]">Trade Discount</p>
                <p className="text-lg font-semibold text-[#555259]">
                    {PriceHandler(prod?.discount?.trade_discount)}
                </p>
            </div>
            <div className="flex items-center justify-between pt-1">
                <p className="text-sm font-normal text-[#555259]">Additional Discount </p>
                <p className="text-lg font-semibold text-[#555259]">
                    {PriceHandler(prod?.discount?.additional_discount)}
                </p>
            </div>
            <div className="tooltip-arrow" data-popper-arrow />
        </div>
    );
}
